

import * as React from "react";

const PDFViewerIframeEsign = ({ urldata }) => {
  return (
    <div style={{ height: "100%" }}>
      <iframe src={urldata} width="99%" height="100%" title="PDF Viewer" />
    </div>
  );
};

export default PDFViewerIframeEsign;
